import React from "react";
import "./Home.css";
import ImageCarousel from "./ImageCarousel";
import Product from "./Product";

function Home() {
  return (
    <div className="home">
      <div className="home_container">
        <ImageCarousel />
        <div className="home_row">
          <Product
            id="12321341"
            title="The Lean Startup : How Constant Innovation Creates Radically Successful Businesses Paperback"
            price={29.99}
            image="https://images-na.ssl-images-amazon.com/images/I/51yT-dDfV7L._SX329_BO1,204,203,200_.jpg"
            rating={2}
          />

          <Product
            id="49538094"
            title="Kenwood kMix Stand Mixer For Baking,Styling Kitchen Mixer with K-beater,Dough Hook and Wisk,5 Litre Glass Bowl"
            price={239.0}
            image="https://m.media-amazon.com/images/I/61fuqOCyW6L._AC_UY218_.jpg"
            rating={4}
          />
          <Product
            id="12321342"
            title="Whirlpool 7 Kg 5 Star Semi-Automatic Top Loading Washing Machine (SUPERB ATOM 7.0, Grey Dazzle, TurboScrub Technology)"
            price={9190}
            image="https://images-eu.ssl-images-amazon.com/images/I/41qQlV0UTDL._AC_US218_FMwebp_QL70_.jpg"
            rating={4}
          />
        </div>
        <div className="home_row">
          <Product
            id="4903850"
            title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Moniter"
            price={9199.0}
            rating={3}
            image="https://m.media-amazon.com/images/I/91pi34PiUPL._AC_UY218_.jpg"
          />
          <Product
            id="234445930"
            title="Amaxon Echo (3rd generation ) | Smart speaker with Alexa,Charcoal Fabric"
            price={998.99}
            rating={5}
            image="https://m.media-amazon.com/images/I/61EXU8BuGZL._AC_UY218_.jpg"
          />
          <Product
            id="3254354345"
            title="New Apple iPad Pro (12.9-inch,Wi-Fi, 128GB)-Silver (4th generation)"
            price={49598.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/61bLMtJcUWL._AC_UY218_.jpg"
          />
        </div>
        <div className="home_row">
          <Product
            id="90829333"
            title="Dell Alienware M15 R2 15.6-inch FHD Laptop (9th Gen Core i9-9980HK/16GB/1TB SSD/Windows 10 + MS Office/8GB NVIDIA 2080 Graphics), Lunar Light"
            price={322899.0}
            rating={4}
            image="https://m.media-amazon.com/images/I/61FjdoHidqL._AC_UY218_.jpg"
          />
          <Product
            id="90829334"
            title="Corsair HS35 Stereo Gaming Headset - Headphones Designed for PC and Mobile – Red"
            price={3783.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/61kG30z4j8L._AC_UY218_.jpg"
          />
        </div>
        <div className="home_row">
          <Product
            id="3254354335"
            title="Apple Watch Series 3 (GPS, 42mm) - Space Grey Aluminium Case with Black Sport Band"
            price={23900}
            rating={5}
            image="https://images-eu.ssl-images-amazon.com/images/I/41RLXO5JUhL._AC_US160_FMwebp_QL70_.jpg"
          />
          <Product
            id="90829332"
            title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Moniter-Super Ultra wide Dual WQHD 5120 x 1440"
            price={20598.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/81vlA84pg6L._AC_UY218_.jpg"
          />
          <Product
            id="12323423"
            title="Amazon Brand - Solimo Stainless Steel Kitchen Press/Noodles/Murukku maker"
            price={349}
            image="https://m.media-amazon.com/images/I/71XZyRPY5GL._AC_UL320_.jpg"
            rating={4}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
